// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-section[data-v-0f562601]{width:450px;margin:0 auto;padding:100px 0}@media only screen and (max-width:600px){.error-section[data-v-0f562601]{width:auto;margin:10px;padding:50px 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
